  export const menuHeaderHandler = ( navigationKey,navigate ) => {
  
    if (navigationKey.startsWith("tel:")) {
      window.location.href = navigationKey;
    } else if (navigationKey.startsWith("http")) {
      window.open(navigationKey);
    } else if (navigationKey.endsWith("Ref")) {
      navigate("/", {
        state: {
          focusServices: navigationKey.replace("Ref", ""),
        },
      });
    } else {
      navigate(`/${navigationKey}`);
    }
  
  };
